import { BaseForm } from "./BaseForm";
import { validate } from "../Validation/validator";

export class PasswordResetForm extends BaseForm {
    errors = {
        password: false,
        passwordConfirm: false,
    };

    /**
     * Submit the reset form with full validation.
     * @param {Event} event - Submit click event
     */
    submit(event) {
        // @ts-ignore - event.target is HTMLElement in runtime
        const form = event.target.closest("form");
        if (!form) {
            return;
        }

        const passwordField = form.querySelector("#password");
        if (passwordField) {
            this.errors.password = validate("password", { field: passwordField }, form);
        }

        const passwordConfirmField = form.querySelector("#password_confirm");
        if (passwordConfirmField) {
            this.errors.passwordConfirm = validate(
                "string",
                {
                    field: passwordConfirmField,
                    rules: {
                        confirm:
                            passwordField && passwordField instanceof HTMLInputElement
                                ? passwordField.value
                                : this.password,
                    },
                },
                form
            );
        }

        this.inValid = this.validate();
        if (!this.inValid) {
            form.submit();
        }
    }
}
